import { useSelector } from "react-redux";
import { formOpenSelector } from "../../reducers/rhapsody";
import { InstrumentForm } from "../instrumentForm/instrumentForm";
import { PipelineForm } from "../pipelineForm/pipelineForm";
import { PipelineImport } from "../pipelineImport/pipelineImport";
import { SectionForm } from "../sectionForm/sectionForm";
import { FamilyForm } from "../familyForm/familyForm";
import { TestPipeline } from "../testPipeline/testPipeline";
import { NoteTypeForm } from "../noteTypeForm/noteTypeForm";
import { TosVersionForm } from "../tosVersionForm/tosVersionForm";
import { SectionRoleForm } from "../roleForm/roleForm";
import { HookDrawer } from "../hookDrawer/hookDrawer";
import { FormForm } from "../formForm/formForm";

/**
 *
 * @returns {ReactElement} CreateCenter page
 */
export function CreateCenter() {
  const pipelineOpen = useSelector(formOpenSelector("pipeline"));
  const pipelineImportOpen = useSelector(formOpenSelector("pipelineImport"));
  const instrumentOpen = useSelector(formOpenSelector("instrument"));
  const sectionOpen = useSelector(formOpenSelector("section"));
  const noteTypeOpen = useSelector(formOpenSelector("noteType"));
  const tosVersionOpen = useSelector(formOpenSelector("tosVersion"));
  const familyOpen = useSelector(formOpenSelector("family"));
  const roleOpen = useSelector(formOpenSelector("role"));
  const testPipeline = useSelector(formOpenSelector("testPipeline"));
  const hookOpen = useSelector(formOpenSelector("hook"));
  const formOpen = useSelector(formOpenSelector("form"));

  return (
    <>
      {pipelineOpen ? <PipelineForm /> : []}
      {pipelineImportOpen ? <PipelineImport /> : []}
      {instrumentOpen ? <InstrumentForm /> : []}
      {sectionOpen ? <SectionForm /> : []}
      {familyOpen ? <FamilyForm /> : []}
      {roleOpen ? <SectionRoleForm /> : []}
      {noteTypeOpen ? <NoteTypeForm /> : []}
      {tosVersionOpen ? <TosVersionForm /> : []}
      {testPipeline ? <TestPipeline /> : []}
      {hookOpen ? <HookDrawer /> : []}
      {formOpen ? <FormForm /> : []}
    </>
  );
}
